import classNames from "classnames";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import styles from "../filterStyles.css";

interface Props {
  active: boolean;
  text: string;
  content?: string;
  onClick(): void;
}
export const FilterLabel = ({ active, text, content, onClick }: Props) => {
  return (
    <div
      className={classNames(styles["entry-container"], { [styles.selected]: !!active })}
      onClick={onClick}
    >
      <div className={classNames(styles.description)}>
        {text}
        {!!active && (
          <div className={styles.applied}>
            <L10n id={"inbox.moreFilters.applied"} />
          </div>
        )}
      </div>
      {content && <span className={styles.subdescrption}>{content}</span>}
    </div>
  );
};
